import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const ResetPasswordTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  text-align: center;
`

export const ResetPasswordWrapper = styled.div`      
  padding: 32px;
  border-radius: 8px;
  background: white;
  margin-top: 248px;  
`

export const ResetPasswordFooterWrapper = styled.div`
  display: flex;
  justify-content: center;  
  margin-top: 32px;
`

export const ResetPasswordFooterText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-left: 8px;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: #0AA1F4;
`
